
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-plans",
      function () {
        return require("private-next-pages/learning-plans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-plans"])
      });
    }
  